import { render, staticRenderFns } from "./WsStateHasMany.vue?vue&type=template&id=60145c24&"
import script from "./WsStateHasMany.vue?vue&type=script&lang=js&"
export * from "./WsStateHasMany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports